import { render, staticRenderFns } from "./list-celebrate.vue?vue&type=template&id=53d012d8"
import script from "./list-celebrate.vue?vue&type=script&lang=js"
export * from "./list-celebrate.vue?vue&type=script&lang=js"
import style0 from "./list-celebrate.vue?vue&type=style&index=0&id=53d012d8&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports